module.exports = __webpack_public_path__ + "static/media/gq.88946f8a.svg";